import { render, staticRenderFns } from "./TheProductListBreadcrumbs.vue?vue&type=template&id=1ea649b2&"
import script from "./TheProductListBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TheProductListBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea649b2')) {
      api.createRecord('1ea649b2', component.options)
    } else {
      api.reload('1ea649b2', component.options)
    }
    module.hot.accept("./TheProductListBreadcrumbs.vue?vue&type=template&id=1ea649b2&", function () {
      api.rerender('1ea649b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductListBreadcrumbs.vue"
export default component.exports